/* PLEENA · rendimiento
   1) Mide los fps reales y degrada por escalones si el aparato no aguanta.
   2) Solo anima las secciones que están en pantalla.
   3) Pausa las partículas (canvas) cuando su sección sale de vista.
   Si este archivo no carga, la página sigue funcionando como siempre: todas las
   clases que pone son ADITIVAS. */
(function () {
  'use strict';
  var html = document.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---------- 1. escalones de calidad ---------- */
  var NIVEL = 0; // 0 = todo, 1 = lowfx, 2 = minfx
  function bajar(n, motivo) {
    if (n <= NIVEL) return;
    NIVEL = n;
    if (n >= 1) html.classList.add('pl-lowfx');
    if (n >= 2) html.classList.add('pl-minfx');
    html.setAttribute('data-pl-fx', String(n));
    if (n >= 1) apagarCanvas();   // ocultarlo no basta: su rAF seguiría corriendo
    if (window.console && console.info) console.info('[pleena] calidad ' + n + ' :: ' + motivo);
  }

  /* al degradar, las partículas se detienen de verdad */
  function apagarCanvas() {
    if (!window.tsParticles || !tsParticles.dom) return;
    try {
      var d = tsParticles.dom();
      for (var i = 0; i < d.length; i++) { d[i].pause(); if (d[i].destroy) d[i].destroy(); }
    } catch (e) {}
  }

  /* pistas del aparato, antes incluso de medir */
  try {
    var mem = navigator.deviceMemory;
    var red = navigator.connection && navigator.connection.effectiveType;
    if (mem && mem <= 1) bajar(2, 'memoria ' + mem + 'GB');
    else if (mem && mem <= 2) bajar(1, 'memoria ' + mem + 'GB');
    if (red && /(^|-)2g$/.test(red)) bajar(1, 'red ' + red);
    if (navigator.connection && navigator.connection.saveData) bajar(2, 'ahorro de datos');
  } catch (e) {}
  if (reduce) bajar(2, 'prefers-reduced-motion');

  /* medición real: dos ventanas, para no castigar el arranque */
  function medir(espera, ms, cb) {
    setTimeout(function () {
      var n = 0, t0 = 0;
      function paso(t) {
        if (!t0) t0 = t;
        n++;
        if (t - t0 < ms) requestAnimationFrame(paso);
        else cb(n * 1000 / (t - t0));
      }
      requestAnimationFrame(paso);
    }, espera);
  }
  function juzgar(fps, donde) {
    if (fps < 26) bajar(2, donde + ' ' + fps.toFixed(0) + 'fps');
    else if (fps < 38) bajar(1, donde + ' ' + fps.toFixed(0) + 'fps');
  }

  if (!reduce && 'requestAnimationFrame' in window) {
    /* en reposo casi todo va bien; los tirones salen AL SCROLLEAR, así que la
       medición que manda es la del primer scroll de verdad. En Safari de iOS es
       además la única pista útil: no existen deviceMemory ni hardwareConcurrency. */
    medir(900, 1000, function (fps) { juzgar(fps, 'quieto'); });

    var yaMedido = false;
    function alScrollear() {
      if (yaMedido) return;
      yaMedido = true;
      window.removeEventListener('scroll', alScrollear);
      medir(60, 1000, function (fps) { juzgar(fps, 'scroll'); });
      /* y una segunda pasada más abajo, donde hay más secciones a la vez */
      setTimeout(function () { medir(0, 900, function (f) { juzgar(f, 'scroll2'); }); }, 4000);
    }
    window.addEventListener('scroll', alScrollear, { passive: true });
  }

  /* Si alguna sección pide ignorar "reducir movimiento", se marca el <html>
     para que también las animaciones CSS del fondo (la malla, las órbitas) se
     salten esa preferencia. Sin esto, el JS animaba y el CSS no. */
  function marcarForzado() {
    if (document.querySelector('[data-pic-force],[data-p3d-force]'))
      html.classList.add('pl-force-motion');
  }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', marcarForzado);
  else marcarForzado();

  /* ---------- 2. solo anima lo que se ve ---------- */
  if (!('IntersectionObserver' in window)) { html.classList.add('pl-novis'); return; }

  var vistas = new IntersectionObserver(function (es) {
    for (var i = 0; i < es.length; i++) {
      var el = es[i].target;
      if (es[i].isIntersecting) el.classList.add('is-vis');
      else el.classList.remove('is-vis');
      canvas(el, es[i].isIntersecting);
    }
  }, { rootMargin: '15% 0px 15% 0px', threshold: 0 });

  /* ---------- 3. las partículas se paran fuera de pantalla ---------- */
  function canvas(sec, dentro) {
    var c = sec.querySelectorAll('canvas');
    for (var i = 0; i < c.length; i++) c[i].style.visibility = dentro ? '' : 'hidden';
    if (!window.tsParticles || !tsParticles.dom) return;
    try {
      var d = tsParticles.dom();
      for (var j = 0; j < d.length; j++) {
        var cv = d[j].canvas && d[j].canvas.element;
        if (cv && sec.contains(cv)) dentro ? d[j].play() : d[j].pause();
      }
    } catch (e) {}
  }

  function observar(raiz) {
    var s = (raiz || document).querySelectorAll('.pl');
    for (var i = 0; i < s.length; i++) vistas.observe(s[i]);
    /* el observer entrega su primera lectura en el siguiente frame: hasta entonces
       no activamos las pausas, o habría un parpadeo en el que nada se mueve */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { html.classList.add('pl-perf'); });
    });
    /* seguro: si a los 2.5s ninguna sección quedó marcada como visible, algo
       falló en el observer y las pausas dejarían la página congelada. Se quitan. */
    setTimeout(function () {
      if (!document.querySelector('.pl.is-vis')) {
        html.classList.remove('pl-perf');
        if (window.console) console.warn('[pleena] sin secciones visibles: pausas desactivadas');
      }
    }, 2500);
  }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', function () { observar(); });
  else observar();
  document.addEventListener('shopify:section:load', function (e) { observar(e.target); });
})();
